import React from "react";
import showResult from "./questions";
import "./results.css";
import ResetButton from "./resetbutton";

const Results = () => {
  return (
    <div className="res-content">
      <h1>According to your input, you should use</h1>
      <div className="rmethodName">{showResult}</div>
      <div className="rformButtons">
        <ResetButton></ResetButton>
      </div>
    </div>
  );
};

export default Results;
